import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import OHLGang from "./OHLGang";
import { Close } from '@material-ui/icons';
import { generalforeman } from '../../../../config/apiList';
import Service from '../../../../config/networkutils';
import { withSnackbar } from "notistack";
import { getCookie } from '../../../../utils/CookieHelper';
import MaterialTable from 'material-table';
import { LoopCircleLoading } from 'react-loadingg';
import { getIdFnameLnameObj } from '../../../../utils/reuseFunctions';
import { getPrimaryColor } from '../../../Helper/CommonThings';

const token = getCookie("ptd_ts_token");

const useStyle = (theme) => ({
    headRow: {
        backgroundColor: "#D5E1E5",
    },
    selectedRow: {
        backgroundColor: "#EDFAFF",
    },
})

class OHLStaffTables extends React.Component {
    state = {
        gfs: [],
        showGFAdd: false,
        isLoading: true,
        allOHLEmp: [],
    }

    gfRoleId = null
    ohlroles = null

    componentDidMount() {
        this.gfRoleId = this.props.gfRoleId
        this.ohlroles = this.props.roles

        let ohlemps = []
        for (let empin = 0; empin < this.props.allEmpData.length; empin++) {
            this.ohlroles.forEach(roleId => {
                if (this.props.allEmpData[empin].job_title === roleId) {
                    ohlemps.push(this.props.allEmpData[empin])
                }
            })
        }

        let allGfs = ohlemps.filter(emp => emp.job_title === this.gfRoleId)
        let allGangEmps = ohlemps.filter(emp => emp.job_title !== this.gfRoleId)

        let unAllocatedGF = [...allGfs];
        for (let gfEmpIndex = 0; gfEmpIndex < this.props.gfs.length; gfEmpIndex++) {
            let filteredGfNotAllocatedEmps = unAllocatedGF.filter(emp => emp.id !== this.props.gfs[gfEmpIndex].ptd_employee)
            unAllocatedGF = [...filteredGfNotAllocatedEmps]
        }

        let ohlEempObj = getIdFnameLnameObj(ohlemps)

        this.setState({
            allGfs, ohlEempObj, unAllocatedGF,
            allGangEmps, gfs: this.props.gfs, rolesObj: this.props.rolesObj,
            allSectors: this.props.allSectors, allSectorLupObj: this.props.sector,
            owner_region: this.props.owner_region, owner_delivery_unit: this.props.owner_delivery_unit,
            allActiveRoles: this.props.allActiveRoles, allCRMS: this.props.allCRMS
        }, () => this.setState({ isLoading: false }))
    }

    postOps(data) {
        Service.post(generalforeman, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        }).then(res => {
            let updatedGfs = [...this.state.gfs]
            let Notallocated = [...this.state.unAllocatedGF]
            updatedGfs.push(res.data)
            let removedTheAdded = Notallocated.filter(emp => emp.id !== res.data.ptd_employee)
            this.setState({ gfs: updatedGfs, unAllocatedGF: removedTheAdded, showGFAdd: false }, () => this.props.enqueueSnackbar('Client added successfully', {
                variant: 'success'
            }))
        })

            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    deleteOps(data) {
        Service.delete(generalforeman + data.id + "/", {
            headers: {
                Authorization: "Token " + token,
            }
        }).then(res => {
            let gffs = [...this.state.gfs]
            gffs = gffs.filter(gf => gf.id !== data.id)
            let dupGF = [...this.state.allGfs]
            dupGF = dupGF.filter(gf => gf.id === data.ptd_employee)
            let dupUnAllocatedGF = [dupGF[0], ...this.state.unAllocatedGF]
            this.props.enqueueSnackbar('Delete operation Success !', { variant: 'success' })
            this.setState({ gfs: gffs, unAllocatedGF: dupUnAllocatedGF })
        }).catch(error => {
            this.props.enqueueSnackbar('Delete operation failed !', { variant: 'error' })
        })
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? <LoopCircleLoading color={getPrimaryColor()} /> :
                        <Box>
                            <Box marginTop={2} marginBottom={2} style={{ fontWeight: 'bold', fontSize: "15px" }}>
                                {this.props.name}
                            </Box>
                            <Paper elevation={3} variant={"outlined"}>
                                <OHLGang
                                    ohlEmpObj={this.state.ohlEempObj}
                                    allOHLEmp={this.state.allGangEmps}
                                    allSectors={this.state.allSectors}
                                    allSectorLupObj={this.state.allSectorLupObj}
                                    owner_delivery_unit={this.state.owner_delivery_unit}
                                    owner_region={this.state.owner_region}
                                    gf={this.props.rowData}
                                    rolesObj={this.state.rolesObj}
                                    allActiveRoles={this.state.allActiveRoles}
                                    allCRMS={this.state.allCRMS}
                                    allGangmen={this.props.allGangmen}
                                    option={this.props.option}
                                />

                                <Dialog open={this.state.showGFAdd} onClose={() => this.setState({ showGFAdd: false })} maxWidth={"lg"}>
                                    <DialogTitle>
                                        <Typography>Add General Foreman</Typography>
                                    </DialogTitle>
                                    <DialogContent style={{ padding: 0 }}>
                                        <MaterialTable
                                            title="Employees"
                                            columns={[
                                                { title: 'Employee No', field: 'emp_no', },
                                                { title: 'First Name', field: 'first_name', },
                                                { title: 'Last Name', field: 'last_name', },
                                                { title: 'Email Address', field: 'email', },
                                                { title: 'Role', field: 'job_title', lookup: this.state.rolesObj },
                                                { title: 'Sub Division', field: 'owner_region', lookup: this.state.owner_region },
                                                { title: 'Operations Lead', field: 'owner_delivery_unit', lookup: this.state.owner_delivery_unit },
                                                { title: 'Sector', field: 'sector', lookup: this.state.sector },
                                                { title: 'Start Date', field: 'start_date', type: 'date' },
                                                { title: 'End Date', field: 'end_date', type: 'date' },
                                            ]}
                                            data={this.state.unAllocatedGF}
                                            isLoading={this.state.isLoading}
                                            options={{
                                                headerStyle: {
                                                    fontWeight: 'bold',
                                                },
                                                padding: 'dense',
                                                showTitle: false,
                                                searchFieldAlignment: 'left',
                                                paging: false,
                                                pageSize: 20
                                            }}
                                            onRowClick={(event, rowData, togglePanel) => {
                                                this.postOps({
                                                    ptd_employee: rowData.id,
                                                    discipline: this.props.discipline
                                                })

                                            }}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        {/* <IconButton><Done /></IconButton> */}
                                        <IconButton onClick={() => this.setState({ showGFAdd: false })}><Close /></IconButton>
                                    </DialogActions>
                                </Dialog>

                            </Paper>
                        </Box>
                }
            </>
        );
    }
}

export default withSnackbar(withStyles(useStyle)(OHLStaffTables));